import creer from "../Assets/tech-crer-size.png";
import profiter from "../Assets/slide-profiter-application-user.png";
import telecharger from "../Assets/slide-telechargement-user-app.png";


const UserAppDownload = [
    {
      title: "Téléchargez l'application !",
      text:
        "Téléchargez LeBonTechnicien pour une Maintenance simplifiée de vos équipements d'énergie renouvelable.",
      icon: "test",
      image: telecharger
    },
    {
      title: "Créez votre profil !",
      text:
        "Créez votre profil, débloquez toutes les fonctionnalités de l'application.",
      icon: "test",
      image: creer
    },
    {
      title: "Profitez de l'application !",
      text:
        "Profitez pleinement de toutes les fonctionnalités de l'application maintenant.",
      icon: "test",
      image: profiter
    }
];

export default UserAppDownload;